import { Translate } from "@/components/Translate";
import styles from "../BuyBox/BuyBox.module.css";

type StatusColor = "red" | "yellow" | "green" | "gray";

const getStockStatus = (
	stock: string | number | boolean | undefined,
): { color: StatusColor; text: string } => {
	if (!stock || stock === "no") {
		return { color: "red", text: "Out of stock" };
	}
	if (stock === "few") {
		return { color: "yellow", text: "Few left" };
	}
	if (stock === "yes" || stock === "infinite" || (typeof stock === "number" && stock > 0)) {
		return { color: "green", text: "In stock" };
	}

	return { color: "gray", text: "Unknown" };
};

export const StockStatusIndicator = ({
	stock,
}: { stock: string | number | boolean | undefined }) => {
	const status = getStockStatus(stock);

	const colorClassMap: Record<StatusColor, string> = {
		red: styles.redIndicator,
		yellow: styles.yellowIndicator,
		green: styles.greenIndicator,
		gray: styles.grayIndicator,
	};

	const colorClass = colorClassMap[status.color as StatusColor];

	return (
		<span className={styles.container}>
			<span className={`${styles.indicator} ${colorClass}`} />
			<span className={styles.statusText}>
				<Translate>{status.text}</Translate>
			</span>
		</span>
	);
};
